import { createReducer, on } from "@ngrx/store";
import { GenericStoreApiData } from "src/components/shared-components/interfaces/generic-store-api-data";
import {
  cardProgrammerLoadErrorAction,
  cardProgrammerLoadSuccessAction,
  cardProgrammerStartLoadAction,
  cardProgrammerUnsetKeyStoreAction,
} from "../actions/card-programmer.actions";

/**
 * Initial state of card programmer store
 */
const initialState: GenericStoreApiData = {
  loaded: false,
  errorGeneric: false,
  errorNotYetImplemented: false,
  isOldDataInUse: false,
  data: null,
};

/**
 * Card programmer reducer
 */
export const CardProgrammerReducer = createReducer(
  initialState,
  on(
    cardProgrammerUnsetKeyStoreAction,
    (cardProgrammerObject: GenericStoreApiData, action) => {
      return initialState;
    }
  ),
  on(
    cardProgrammerStartLoadAction,
    (cardProgrammerObject: GenericStoreApiData, action) => {
      return { ...cardProgrammerObject, loaded: false };
    }
  ),
  on(
    cardProgrammerLoadSuccessAction,
    (cardProgrammerObject: GenericStoreApiData, action) => {
      return {
        loaded: true,
        errorGeneric: false,
        errorNotYetImplemented: false,
        isOldDataInUse: false,
        data: action.listCardProgrammerObject,
      };
    }
  ),
  on(
    cardProgrammerLoadErrorAction,
    (cardProgrammerObject: GenericStoreApiData, action) => {
      return {
        loaded: true,
        errorGeneric: true,
        errorNotYetImplemented: false,
        isOldDataInUse: false,
        data: null,
      };
    }
  )
);
